<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>{{ action == "create" ? "Create" : "Edit" }} App Permission</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>App Permission Details</v-card-title>
        <v-card-subtitle>Please fill in all of the details</v-card-subtitle>
        <div style="padding: 10px">
          <v-form ref="info_form">
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="App Permission Name"
                v-model="permission_name"
                :error_message="permission_name_error_message"
                placeholder="e.g Super Admin"
                :rules="[
                  () => !!permission_name || 'Permission name is required',
                ]"
                @input="clear_error_message('permission_name')"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowTextField
                :is_required="true"
                title="Description"
                v-model="permission_description"
                placeholder="e.g Access to all of the feature"
                :rules="[
                  () => !!permission_description || 'Description is required',
                ]"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowComboBox
                :is_required="false"
                title="Company"
                v-model="existing_company_list"
                :items="company_list"
                :multiple="true"
                placeholder="Select company that entitled for this permission"
              ></RowComboBox>
            </div>
          </v-form>
        </div>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>Permission Details</v-card-title>
        <v-card-subtitle
          >Select different permission to configure the feature accessibility
          for Nu Vending Mobile App</v-card-subtitle
        >
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="default_permission_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          hide-default-footer
          :items-per-page="120"
        >
          <template v-slot:[`item.editor`]="props">
            <div v-if="props.item.editor != 'NA'">
              <v-checkbox v-model="props.item.editor" value></v-checkbox>
            </div>
          </template>
          <template v-slot:[`item.viewer`]="props">
            <div v-if="props.item.viewer != 'NA'">
              <v-checkbox v-model="props.item.viewer" value></v-checkbox>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div style="height: 150px"></div>
    <div style="position: fixed; left: 0; right: 0; width: auto; bottom: 0">
      <v-card
        min-height="100"
        style="padding-top: 10px"
        flat
        outlined
        :style="{
          paddingLeft: generalSpacingLeftRight + '%',
          paddingRight: generalSpacingLeftRight + '%',
        }"
      >
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="ma-3">
            <v-btn
              style="text-transform: capitalize"
              outlined
              @click="$router.push({ path: '/app-permission' })"
              :disabled="is_submitting"
              >Cancel</v-btn
            >
          </div>
          <div class="ma-3">
            <v-btn
              depressed
              style="text-transform: capitalize"
              class="white--text"
              color="primary"
              :disabled="is_submitting"
              :loading="is_submitting"
              @click="update_permission"
              >Save</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import RowTextField from "../components/RowTextField.vue";
import RowComboBox from "../components/RowComboBox.vue";

export default {
  components: {
    RowTextField,
    RowComboBox,
  },
  data: function () {
    return {
      action: this.$route.params.id == "create" ? "create" : "edit",
      app_permission_doc_id: "",
      permission_name: "",
      permission_description: "",
      app_permission_list: [],
      current_user_company_doc_id: "",
      existing_company_list: [],
      permission_name_error_message: "",
      company_list: [],
      actual_company_list: [],
      table_loading: false,
      headers: [
        {
          text: "Feature",
          value: "feature",
          divider: true,
          sortable: false,
        },
        {
          text: "Editor",
          value: "editor",
          divider: true,
          sortable: false,
        },
        {
          text: "Viewer",
          value: "viewer",
          divider: true,
          sortable: false,
        },
      ],
      default_permission_list: [],
      is_submitting: false,
    };
  },
  methods: {
    async get_permission_detail() {
      const response = (
        await this.send_http_request("getPermissionDetails", {
          permission_doc_id: this.$route.params.id,
        })
      ).data;
      if (response.status == "OK") {
        this.permission_name = response.result.permission_name;
        this.permission_description = response.result.permission_description;
        this.existing_company_list = [];
        response.result.company_list.forEach((company_doc_id) => {
          var index = this.actual_company_list.findIndex(
            (x) => x.company_doc_id == company_doc_id
          );
          if (index > -1) {
            this.existing_company_list.push(
              `${this.actual_company_list[index].company_id} - ${this.actual_company_list[index].company_name}`
            );
          }
        });
        response.result.permissions.forEach((permission) => {
          var index = this.default_permission_list.findIndex(
            (x) => x.feature == permission.feature
          );
          if (index > -1) {
            if (permission.editor != "NA") {
              this.default_permission_list[index].editor = permission.editor;
            }
            if (permission.viewer != "NA") {
              this.default_permission_list[index].viewer = permission.viewer;
            }
          }
        });
      } else {
        this.show_close_loading("close");
        this.$router
          .push({
            name: "AppPermissionDetailScreen",
            params: { id: "create" },
          })
          .catch((err) => {});
      }
    },
    async update_permission() {
      if (this.$refs.info_form.validate()) {
        this.is_submitting = true;
        const validate_response = (
          await this.send_http_request("verifyPermissionName", {
            permission_doc_id:
              this.action == "edit" ? this.$route.params.id : "",
            permission_name: this.permission_name,
          })
        ).data;
        if (validate_response.status == "OK") {
          var temp_company_list = [];
          this.existing_company_list.forEach((selected_company) => {
            var index = this.actual_company_list.findIndex(
              (x) => x.company_id == selected_company.split(" - ")[0]
            );
            if (index > -1) {
              temp_company_list.push(
                this.actual_company_list[index].company_doc_id
              );
            }
          });
          const result = (
            await this.send_http_request(
              this.action == "create"
                ? "createAppPermission"
                : "updateAppPermission",
              {
                permission_doc_id: this.$route.params.id,
                permission_name: this.permission_name,
                permission_description: this.permission_description,
                permissions: this.default_permission_list,
                company_list: temp_company_list,
              }
            )
          ).data;
          this.is_submitting = false;
          if (result.status == "OK") {
            this.show_snack_bar("success", "App permission updated");
            this.$router.push({ path: "/app-permission" });
          } else {
            this.show_snack_bar("error", "Something went wrong");
          }
        } else {
          this.is_submitting = false;
          this.permission_name_error_message = "Duplicate permission name";
          this.show_snack_bar("error", "Duplicate permission name");
        }
      }
    },
    clear_error_message(type) {
      if (type == "permission_name") {
        this.permission_name_error_message = "";
      }
    },
    load_company() {
      return new Promise((resolve, reject) => {
        this.send_http_request("getAllCompaniesWithCompanyID", {
          company_doc_id: "",
        })
          .then((response) => {
            if (response.data.status == "OK") {
              response.data.result.forEach((company) => {
                this.company_list.push(
                  `${company.company_id} - ${company.company_name}`
                );
                this.actual_company_list.push(company);
              });
            }
            resolve("success");
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    load_default_permission_category() {
      return new Promise((resolve, reject) => {
        this.send_http_request("getAllPermissionCategory", {})
          .then((response) => {
            if (response.data.status == "OK") {
              response.data.result.forEach((permission) => {
                this.default_permission_list.push(permission);
              });
            }
            resolve("success");
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  async mounted() {
    this.show_close_loading("show", "Loading...");
    await this.load_default_permission_category();
    await this.load_company();
    if (this.$route.params.id != "") {
      this.get_permission_detail();
    }
    this.show_close_loading("close");
  },
  created() {
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      this.$router.push({ name: "HomeScreen" }).catch((err) => {});
    }
    // Update store
    var payload = {
      headerType: "needHeader",
      currentPage: "AppPermissionScreen",
    };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>